import React from 'react';
import {observer} from 'mobx-react';
import {ConnectivityController} from './ConnectivityController';
import {IConnectivityControllerAngular} from './connectivity-check.stores';

interface ConnectivityProps {
    connectivityController: ConnectivityController;
    connectivityControllerAngular: IConnectivityControllerAngular;
}

@observer
export class Connectivity extends React.Component<ConnectivityProps> {
    render(): JSX.Element {
        const {connectivityController, connectivityControllerAngular} = this.props;
        const iframeSrc = connectivityControllerAngular?.getIframeSrc();

        return (
            <div className='connectivity-iframe-container'>
                <iframe id='iframe-connectivity' className='iframe-connectivity-frame' src={iframeSrc} />
                <div className='btn-container'>
                    <button
                        type='button'
                        className='btn btn-connectivity'
                        onClick={() => connectivityControllerAngular?.goToInvite()}>
                        {connectivityController.translate('REACT.INVITE.VIEW.CLOSE')}
                    </button>
                </div>
            </div>
        );
    }
}

export default Connectivity;
